"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

/**
 * Sayfa geçişlerinde üstte ince bir ilerleme çubuğu gösterir.
 * Bağlantıya tıklandığı anda başlar, yeni sayfa açılınca kaybolur —
 * böylece kullanıcı tıklamasının işlendiğini görür.
 */
export function GecisCubugu() {
  const pathname = usePathname();
  const [aktif, setAktif] = useState(false);

  // Site içi bir bağlantıya tıklanınca çubuğu başlat
  useEffect(() => {
    const tikla = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      const a = (e.target as HTMLElement | null)?.closest("a");
      if (!a) return;
      const href = a.getAttribute("href");
      if (!href || a.target === "_blank" || href.startsWith("#") || href.startsWith("mailto:")) return;
      // Yalnızca site içi ve mevcut sayfadan farklı adresler
      const hedef = new URL(a.href, window.location.href);
      if (hedef.origin !== window.location.origin) return;
      if (hedef.pathname === window.location.pathname) return;
      setAktif(true);
    };
    document.addEventListener("click", tikla, true);
    return () => document.removeEventListener("click", tikla, true);
  }, []);

  // Yeni sayfa yüklenince kapat. Gezinme tamamlandığının tek sinyali pathname
  // değişimi olduğu için çubuğun sıfırlanması bilerek burada yapılıyor.
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setAktif(false);
  }, [pathname]);

  // Çok uzun sürerse takılı kalmasın
  useEffect(() => {
    if (!aktif) return;
    const t = setTimeout(() => setAktif(false), 4000);
    return () => clearTimeout(t);
  }, [aktif]);

  if (!aktif) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[100] h-[3px] overflow-hidden" aria-hidden>
      <div className="yukleme-cubugu h-full w-full bg-gradient-to-r from-[#7c5cff] via-[#9d6bff] to-[#22d3ee] shadow-[0_0_14px_2px_rgba(124,92,255,0.8)]" />
    </div>
  );
}
